module.exports = "//static.hsappstatic.net/marketplace-storefront-base/static-1.11901/assets/images/apps_for_sales.png"